// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1_wb6","cls2":"CreateSocialItem-cls2_xWo CreateSocialItem-cls1_wb6"};